<template>
  <div class="obituary-single__hero-name-date">
    <h1 class="obituary__title">
      <span>{{ creatorTexts.inMemoryOf }}</span>
      {{ name }}
    </h1>
    <p class="obituary-single__hero-date">{{ birth }} - {{ death }}</p>
    <div v-if="isEditMode">
      <button class="btn invisible hero-text-edit" @click="toggleModal">
        {{ creatorTexts.editNameDate }}
      </button>
      <modal
        :disabled="false"
        :modal-heading="creatorTexts.nameDateHeading"
        :modal-open="modalOpen"
        :toggle-modal="toggleModal"
      >
        <div class="hero-name-date-form">
          <div class="hero-name-date-form__col">
            <label>{{ creatorTexts.firstName }}</label>
            <input
              v-model="cFirstName"
              type="text"
              :placeholder="creatorTexts.firstName"
            />
          </div>
          <div class="hero-name-date-form__col">
            <label>{{ creatorTexts.lastName }}</label>
            <input
              v-model="cLastName"
              type="text"
              :placeholder="creatorTexts.lastName"
            />
          </div>
          <div class="hero-name-date-form__col--full">
            <label>{{ creatorTexts.nickname }}</label>
            <input
              v-model="cNickname"
              type="text"
              :placeholder="creatorTexts.nickname"
            />
          </div>
          <div class="hero-name-date-form__col--full">
            <label>{{ creatorTexts.yearOfBirth }}</label>

            <input
              v-model="cYearOfBirth"
              :class="{ error: showErrorMessage }"
              type="text"
              :placeholder="creatorTexts.yearOfBirth"
              pattern="\d{4}"
              maxlength="4"
            />

            <p v-if="showErrorMessage" class="hero-name-date-form__error">
              {{ creatorTexts.yearOfBirthError }}
            </p>
          </div>
          <div class="hero-name-date-form__col--full">
            <label>{{ creatorTexts.deceasedDate }}</label>

            <input
              v-model="cDeceasedDate"
              type="date"
              :placeholder="creatorTexts.deceasedDate"
            />
          </div>
        </div>
        <button
          class="btn cta btn-sm hero-text-edit"
          :class="{ 'btn-loading': isSavingDateText }"
          @click.prevent="save"
        >
          <Loader :loading="isSavingDateText" />
          <span v-text="creatorTexts.save" />
        </button>
        <button class="btn invisible" @click="reset">
          {{ creatorTexts.cancel }}
        </button>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import { format, parse } from 'date-fns';
import Modal from 'Components/Modal.vue';
import Loader from 'Components/loader/Loader.vue';
export default {
  name: 'HeroNameDate',
  components: {
    Modal,
    Loader,
  },
  data() {
    return {
      creatorTexts: lavendlaObituary.creator,
      oldFirstName: '',
      oldLastName: '',
      oldNickname: '',
      oldyearOfBirth: '',
      oldDeceasedDate: '',
      modalOpen: false,
      date: '',
      showErrorMessage: false,
    };
  },
  computed: {
    ...mapState('creator', [
      'isSavingDateText',
      'isEditMode',
      'firstName',
      'lastName',
      'nickname',
      'yearOfBirth',
      'deceasedDate',
    ]),
    cFirstName: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.setState({ firstName: value });
      },
    },
    cLastName: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.setState({ lastName: value });
      },
    },
    cNickname: {
      get() {
        return this.nickname;
      },
      set(value) {
        this.setState({ nickname: value });
      },
    },
    cYearOfBirth: {
      get() {
        return this.yearOfBirth;
      },
      set(value) {
        this.setState({ yearOfBirth: value });
      },
    },
    cDeceasedDate: {
      get() {
        return this.deceasedDate;
      },
      set(value) {
        this.setState({ deceasedDate: value });
      },
    },

    name() {
      const firstName = this.firstName
        ? this.firstName
        : this.isEditMode
          ? this.creatorTexts.firstName
          : '';
      const lastName = this.lastName
        ? this.lastName
        : this.isEditMode
          ? this.creatorTexts.lastName
          : '';
      const nickname = this.nickname ? this.nickname : '';

      if (nickname) {
        return `${firstName} "${nickname}" ${lastName}`;
      } else {
        return `${firstName} ${lastName}`;
      }
    },
    birth() {
      if (this.yearOfBirth) {
        return this.yearOfBirth;
      } else {
        return this.isEditMode ? '0000' : '';
      }
    },
    death() {
      if (this.deceasedDate) {
        return format(
          parse(this.deceasedDate, 'yyyy-MM-dd', new Date()),
          'yyyy'
        );
      } else {
        return this.isEditMode ? '0000' : '';
      }
    },
    years() {
      const currentYear = new Date().getFullYear();
      const list = Array.from(
        { length: (currentYear - 1900) / 1 + 1 },
        (_, i) => 1900 + i
      )
        .reverse()
        .map((year) => ({ label: year, value: year }));
      return list;
    },
  },
  beforeMount() {
    const { firstName, lastName, nickname, yearOfBirth, deceasedDate } =
      this.$mountEl.dataset;
    this.setState({ firstName, lastName, nickname, yearOfBirth, deceasedDate });
    this.oldFirstName = this.firstName;
    this.oldLastName = this.lastName;
    this.oldNickname = this.nickname;
    this.oldyearOfBirth = this.yearOfBirth;
    this.oldDeceasedDate = this.deceasedDate;
  },
  methods: {
    ...mapMutations('creator', ['setState']),
    ...mapActions('creator', ['saveNameDate']),
    isValidYear(year) {
      if (!year) {
        return true;
      }

      if (year.length !== 4) {
        return false;
      }

      if (isNaN(year)) {
        return false;
      }

      return true;
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    async setYear({ label, value }) {
      await this.setState({ yearOfBirth: value });
    },
    async reset() {
      await this.setState({
        firstName: this.oldFirstName,
        lastName: this.oldLastName,
        nickname: this.oldNickname,
        yearOfBirth: this.oldyearOfBirth,
        deceasedDate: this.oldDeceasedDate,
      });
      this.modalOpen = false;
    },
    async save() {
      if (!this.isValidYear(this.yearOfBirth)) {
        this.showErrorMessage = true;
        return;
      }

      this.showErrorMessage = false;
      await this.saveNameDate();
      this.oldFirstName = this.firstName;
      this.oldLastName = this.lastName;
      this.oldNickname = this.nickname;
      this.oldyearOfBirth = this.yearOfBirth;
      this.oldDeceasedDate = this.deceasedDate;
      this.modalOpen = false;
    },
  },
};
</script>
